import { t } from '@lingui/core/macro';

export function periodLabel(period?: string): string {
  switch (period) {
    case 'monthly':
      return t`Monthly`;
    case 'quarterly':
      return t`Quarterly`;
    case 'yearly':
      return t`Yearly`;
    case 'weekly':
      return t`Weekly`;
    default:
      return period ?? '';
  }
}

export function yearTypeLabel(yearType?: string): string {
  switch (yearType) {
    case 'CY':
      return t`Calendar year`;
    case 'FY':
      return t`Fiscal year`;
    default:
      return yearType ?? '';
  }
}

export function dueOnLabel(dueOn?: string): string {
  switch (dueOn) {
    case undefined:
    case 'end-of-month':
      return t`Due at end of month`;
    case 'day-5':
      return t`Due on day 5`;
    case 'day-10':
      return t`Due on day 10`;
    case 'day-15':
      return t`Due on day 15`;
    case 'following-friday':
      return t`Due the following Friday`;
    default:
      return dueOn;
  }
}
